import { apiSlice } from './apiSlice';
import { DAILYSTOCKS_URL } from '../constants';

export const dailyStocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new dailyStock
    createDailyStock: builder.mutation({
      query: (dailyStock) => ({
        url: DAILYSTOCKS_URL,
        method: 'POST',
        body: dailyStock,
      }),
    }),

    // Get dailyStock details by ID
    getDailyStockDetails: builder.query({
      query: (id) => ({
        url: `${DAILYSTOCKS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get logged-in user's dailyStocks
    getMyDailyStocks: builder.query({
      query: () => ({
        url: `${DAILYSTOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Get all dailyStocks (Admin)
    getDailyStocks: builder.query({
      query: () => ({
        url: DAILYSTOCKS_URL,
      }),
      keepUnusedDataFor: 5,
    }),

    // Mark dailyStock as delivered
    deliverDailyStock: builder.mutation({
      query: (dailyStockId) => ({
        url: `${DAILYSTOCKS_URL}/${dailyStockId}/deliver`,
        method: 'PUT',
      }),
    }),

    // Delete dailyStock
    deleteDailyStock: builder.mutation({
      query: (dailyStockId) => ({
        url: `${DAILYSTOCKS_URL}/${dailyStockId}`,
        method: 'DELETE',
      }),
    }),

    // Delete specific dailyStock items
    deleteDailyStockItems: builder.mutation({
      query: ({ dailyStockId, dailyStockItemsIndexes }) => ({
        url: `${DAILYSTOCKS_URL}/${dailyStockId}/delete-items`,
        method: 'PUT',
        body: { dailyStockItemsIndexes },
      }),
    }),

    // Update dailyStock
    updateDailyStock: builder.mutation({
      query: ({ dailyStockId, ...body }) => ({
        url: `${DAILYSTOCKS_URL}/${dailyStockId}`,
        method: 'PUT',
        body,
      }),
    }),

    // ⭐ NEW: Fix missing product IDs (admin)
    fixMissingProductIds: builder.mutation({
      query: () => ({
        url: `${DAILYSTOCKS_URL}/fix-missing-ids`,
        method: 'PUT',
      }),
    }),

    // ⭐ NEW: Repair ALL dailyStocks (admin)
    repairAllDailyStocks: builder.mutation({
      query: () => ({
        url: `${DAILYSTOCKS_URL}/repair-all`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useCreateDailyStockMutation,
  useGetDailyStockDetailsQuery,
  useGetMyDailyStocksQuery,
  useGetDailyStocksQuery,
  useDeliverDailyStockMutation,
  useDeleteDailyStockMutation,
  useDeleteDailyStockItemsMutation,
  useUpdateDailyStockMutation,
  useFixMissingProductIdsMutation,   // ⭐ NEW
  useRepairAllDailyStocksMutation,         // ⭐ NEW
} = dailyStocksApiSlice;
